import {GeneralTerm} from './GeneralTerm';

export class UserTerm {
  static STATUS_OPEN = 'open';
  static STATUS_ACCEPTED = 'accepted';
  id: number;
  term: GeneralTerm;
  status: string;
  acceptedAt: string;
  name: string;
  city: string;
}
